//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.Rebuild.js";
import "../no/SectionList.js";
import "../GeometricUtilities/GeometricUtilities.StyledSweepDoubleOnPathDimBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.StyledSweepReferenceMethodBuilder.js";
import "../GeometricUtilities/GeometricUtilities.RotationSetBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.ScalingSetBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.SurfaceRangeBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"AlternateSolution",1,0],[1,"FirstGuide",0,"Section",0],[0,"FixedStringOption",1,0],[0,"G0Tolerance",1,0],[0,"G1Tolerance",1,0],[1,"GuideRebuildData",0,"GeometricUtilities.Rebuild",0],[1,"InsertedSectionList",0,"SectionList",0],[1,"PivotSetList",0,"GeometricUtilities.StyledSweepDoubleOnPathDimBuilderList",0],[1,"ReferenceMethod",0,"GeometricUtilities.StyledSweepReferenceMethodBuilder",0],[1,"RotationSetList",0,"GeometricUtilities.RotationSetBuilderList",0],[1,"ScalingCurve",0,"Section",0],[0,"ScalingMethodOption",1,0],[1,"ScalingSetList",0,"GeometricUtilities.ScalingSetBuilderList",0],[1,"SecondGuide",0,"Section",0],[1,"SectionList",0,"SectionList",0],[0,"SectionOrientationOption",1,0],[1,"SectionRebuildData",0,"GeometricUtilities.Rebuild",0],[1,"SurfaceRange",0,"GeometricUtilities.SurfaceRangeBuilder",0],[0,"TransitionOption",1,0],[0,"Type",1,0]],[[["value1","value2","path1","path2"],"CreatePivotSet",{R_:{pivotSet:"GeometricUtilities.StyledSweepDoubleOnPathDimBuilder"}},4,0],[["value","path_par","path"],"CreateRotationSet",{R_:{rotationSet:"GeometricUtilities.RotationSetBuilder"}},3,0],[["value_par","depth_par","path_par","path"],"CreateScalingSet",{R_:{scalingSet:"GeometricUtilities.ScalingSetBuilder"}},4,0],[["insertPnt"],"StartInsertingSection",{},1,0],[[],"EndInsertingSection",{},0,0]],[]];
SPLM.Features.StyledSweepBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StyledSweepBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StyledSweepBuilder.Types = Object.freeze({
    "OneGuide" : "OneGuide", "OneGuideOneTouch" : "OneGuideOneTouch", "OneGuideOneOrientation" : "OneGuideOneOrientation", "TwoGuides" : "TwoGuides"});

SPLM.Features.StyledSweepBuilder.TransitionOptions = Object.freeze({
    "Linear" : "Linear", "Cubic" : "Cubic", "Blend" : "Blend"});

SPLM.Features.StyledSweepBuilder.FixedStringOptions = Object.freeze({
    "Guide" : "Guide", "Section" : "Section", "GuideAndSection" : "GuideAndSection"});

SPLM.Features.StyledSweepBuilder.SectionOrientationOptions = Object.freeze({
    "Translate" : "Translate", "KeepAngle" : "KeepAngle", "MakeNormal" : "MakeNormal", "UserDefined" : "UserDefined", "ArcLength" : "ArcLength"});

SPLM.Features.StyledSweepBuilder.ScalingMethodOptions = Object.freeze({
    "Uniform" : "Uniform", "Nonuniform" : "Nonuniform", "ScalingCurve" : "ScalingCurve"});

export default SPLM;